export default __webpack_public_path__ + "static/media/26.b988f43e.png";